const EVENTS_FR = {
  accepted: "Offre acceptée par le client",
  booking_auto_extended: "Prolongation automatique",
  booking_end: "Demande de libération",
  booking_extension: "Demande de prolongation",
  break_repair: "Casses importantes",
  break_repair_2: "Petites casses",
  breakdown: "Panne",
  breakdown_electric: "Panne électrique",
  breakdown_engine: "Panne moteur",
  breakdown_mecanic: "Panne mécanique",
  breakdown_other: "Autre panne",
  canceled: "Annulée",
  closed: "Cloturé",
  confirmed: "Commande confirmée",
  damages_third_parties: "Sinistre-juridique",
  delay_in_delivery: "Retard de livraison",
  deliveryOn: "Livraison le",
  document_compliance: "Conformité des documents",
  events: "{{count}} événements",
  forgetting_extend: "Oubli de prolongation",
  forgetting_recover: "Oubli de récupération",
  from_date: "Début",
  hours_record: "Relevé d'heures",
  immobilisation: "Immobilisation",
  incompetent_operator: "Opérateur incompétent",
  inventory: "Etat des lieux",
  keys: "Clé/Code : perte/non-communiqué",
  machine_delivery: "Livraison",
  machine_retrieval: "Reprise",
  missing_accessory: "Accessoire manquant",
  n1_control: "Contrôle N1",
  n2_control: "Contrôle N2",
  n3_control: "Contrôle N3",
  no_show: "Livraison : No Show",
  open: "Ouvert",
  openEvents: "Événements ouverts",
  operator_change: "Changement d'opérateur",
  other: "Autre",
  other_delivery: "Autre livraison",
  other_request: "Autre demande",
  quality_issue: "Mauvais état matériel",
  retrievalOn: "Reprise le",
  robbery_accessory: "Vol accessoire",
  robbery_article: "Vol machine",
  sent: "Demande reçue",
  to_date: "Fin",
  undeclared_use: "Utilisation non déclarée",
  validated: "Demande de location validée",
  weather: "Intempéries",
  wrong_machine: "Erreur Matériel",
  wrong_reclassification: "Mauvais reclassement loueur",
} as const;

export default EVENTS_FR;
